﻿import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
} from '@mui/material';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import BaseModal from '@/components/modals/BaseModal';
import { close } from '@/store/uiSlice.ts';
import { useI18nContext } from '@/i18n/i18n-react';

const AbsentModal = () => {
    const dispatch = useAppDispatch();
    const open = useAppSelector((state) => state.ui.open.absent);
    const onClose = () => dispatch(close('absent'));
    const { LL } = useI18nContext();

    const absentUsers = useAppSelector((state) => state.modal.absentUsers);

    return (
        <BaseModal
            open={open}
            onClose={onClose}
            maxWidth="xs"
            title={LL.absentModal.title()}
            actions={<Button onClick={onClose}>{LL.common.close()}</Button>}
        >
            <TableContainer component={Paper} variant="outlined">
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>{LL.absentModal.user()}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {absentUsers.map((user, idx) => (
                            <TableRow key={idx}>
                                <TableCell>{user}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </BaseModal>
    );
};

export default AbsentModal;
